import React from "react";

function GuardCommunication() {
    return (
        <div>
            <h2>Communication & Reporting</h2>
            <p>
                Clear and professional communication is essential for security guards. This module covers verbal and non-verbal communication, radio protocol, and how to report incidents accurately and effectively.
            </p>

            <h3>Verbal Communication</h3>
            <ul>
                <li>Speak clearly and confidently</li>
                <li>Use polite, respectful language</li>
                <li>Adapt tone and vocabulary to the situation</li>
                <li>Listen actively and avoid interrupting</li>
            </ul>

            <h3>Non-Verbal Communication</h3>
            <ul>
                <li>Maintain appropriate eye contact</li>
                <li>Use open and calm body language</li>
                <li>Avoid aggressive gestures or posture</li>
                <li>Be aware of personal space</li>
            </ul>

            <h3>Using Radios & Communication Devices</h3>
            <ul>
                <li>Use clear, concise language</li>
                <li>Follow phonetic alphabet and call signs</li>
                <li>Keep messages brief and professional</li>
                <li>Confirm receipt of important messages</li>
            </ul>

            <h3>Incident Reporting</h3>
            <ul>
                <li>Record who, what, when, where, and how</li>
                <li>Be objective — stick to facts, not opinions</li>
                <li>Use incident report forms or digital systems</li>
                <li>Submit reports promptly and securely</li>
            </ul>

            <h3>Interacting with the Public</h3>
            <ul>
                <li>Remain calm and courteous, even under pressure</li>
                <li>Offer assistance and give clear directions</li>
                <li>De-escalate conflict with empathy and professionalism</li>
                <li>Know when to involve supervisors or emergency services</li>
            </ul>

            <h3>Resources</h3>
            <ul>
                <li><a href="https://www.skillsforsecurity.org.uk/" target="_blank" rel="noreferrer">Skills for Security – Communication Training</a></li>
                <li><a href="https://www.suzylamplugh.org/" target="_blank" rel="noreferrer">Suzy Lamplugh Trust – Personal Safety & Conflict Management</a></li>
                <li><a href="https://www.hse.gov.uk/toolbox/managing/reporting.htm" target="_blank" rel="noreferrer">HSE – Reporting Incidents</a></li>
            </ul>
        </div>
    );
}

export default GuardCommunication;
